<template>
  <div v-if="chartLoaded" class="accordion" id="chartFiltersAccordion">
    <div class="accordion-item">
      <!-- <h2 class="text-sm" id="headingOne"> -->
        <!-- <button class="accordion-button" :class="{ 'collapsed': !isExpanded }" type="button" @click="isExpanded = !isExpanded" :aria-expanded="isExpanded" aria-controls="collapseOne"> -->
        <button type="button" class="text-left min-h-[20px] py-[16px] px-[20px] leading-5 w-full" @click="toggleFilters">
          <font-awesome-icon icon="cog" class="text-sm"/>
          Chart Options
        </button>
      <!-- </h2> -->
      <div id="collapseOne" class="accordion-collapse table-vertical-scroll" v-show="isExpanded" aria-labelledby="headingOne">
        <div class="accordion-body">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-4 col-md-6 mb-3">
                <div class="card card-body">
                  <div class="card-header">Time Range</div>
                  <div class="d-flex flex-wrap mb-3" role="group" :title="gatewayTier != 2 ? 'Only subscribed gateways can use chart controls' : ''">
                    <button
                        v-for="range in dateRanges"
                        :key="range.value"
                        type="button"
                        class="btn btn-secondary btn-sm"
                        :class="{ 'custom-active': selectedRange === range.value }"
                        @click="selectRange(range)"
                        :disabled="gatewayTier != 2"
                    >
                      {{ range.label }}
                    </button>
                  </div>
                  <div class="row align-items-end" :title="gatewayTier != 2 ? 'Only subscribed gateways can use chart controls' : ''">
                    <div class="col-5" style="padding-right: 5px; padding-left: 5px;">
                      <label for="fromDate">From</label>
                      <input type="datetime-local"
                            id="fromDate"
                            class="form-control"
                            v-model="fromDate"
                            @change="setFromDate"
                            :disabled="gatewayTier != 2"
                      />
                    </div>
                    <div class="col-5" style="padding-right: 5px; padding-left: 5px;">
                      <label for="toDate">To</label>
                      <input type="datetime-local"
                            id="toDate"
                            class="form-control"
                            v-model="toDate"
                            @change="setToDate"
                            :disabled="gatewayTier != 2"
                      />
                    </div>
                    <div class="col-2" style="padding-bottom: 5px">
                      <button
                          class="btn btn-outline-secondary btn-sm"
                          @click="clearDates"
                          title="Clear Dates"
                          :disabled="gatewayTier != 2"
                      >
                        <i class="bi bi-eraser-fill"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body" :title="gatewayTier != 2 ? 'Only subscribed gateways can use chart controls' : ''">
                    <div class="card-header">AI</div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch"
                             id="aiSwitch"
                             @change="aiToggle"
                             :disabled="!aiEnabled || gatewayTier != 2"
                             :checked="aiEnabledVal"
                      />
                      <label class="form-check-label" for="aiSwitch">Predictions</label>
                    </div>
                    <div
                        class="text-primary"
                        v-if="aiEnabled"
                        :class="{ 'text-decoration-none': !aiEnabled, 'text-decoration-underline': aiEnabled }"
                        :style="{ cursor: aiEnabled ? 'pointer' : 'default', opacity: aiEnabled ? 1 : 0.5 }"
                        @click="aiEnabled && removeOutliers()"
                    >
                      Remove Outliers
                    </div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch" 
                             id="trendlineSwitch"
                             @change="trendlineToggle"
                             :checked="trendlineVal"
                             :disabled="gatewayTier != 2"
                      />
                      <label class="form-check-label" for="trendlineSwitch">Show Trendline</label>
                    </div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch" id="imputationSwitch" :disabled="true"/>
                      <label class="form-check-label" for="imputationSwitch">Data Imputation</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body">
                    <div class="card-header">Timeout and Errors</div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch"
                             id="timeoutSwitch"
                             @change="timeoutToggle"
                             :disabled="!timeouts"
                             :checked="timeoutVal && timeouts"
                      />
                      <label class="form-check-label" for="timeoutSwitch">Show Timeouts</label>
                    </div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch" id="errorSwitch" :disabled="true"/>
                      <label class="form-check-label" for="timeoutSwitch">Show Errors</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-6 mb-3">
                <div class="card">
                  <div class="card-body" :title="gatewayTier != 2 ? 'Only subscribed gateways can use chart controls' : ''">
                    <div class="card-header">Alarms</div>
                    <div class="form-check form-switch mb-2">
                      <input class="form-check-input" type="checkbox" role="switch"
                             id="alarmSwitch"
                             @change="alarmToggle"
                             :disabled="!alarmsEnabled || gatewayTier != 2"
                             :checked="alarmVal && alarms?.length > 0"
                      />
                      <label class="form-check-label" for="alarmSwitch">Show Set Alarms</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import { useStore } from "vuex"
	import {computed, onMounted, watch} from 'vue'
  import { format, parseISO, isValid } from 'date-fns'
  
	export default {
    data() {
      return {
        dateRanges: [
          { value: '30r', label: 'Last 30 readings', diff: null },
          { value: '1h', label: 'Last hour', diff: 60 * 60 * 1000 },
          { value: '12h', label: 'Last 12 hours', diff: 12 * 60 * 60 * 1000 },
          { value: '24h', label: 'Last 24 hours', diff: 24 * 60 * 60 * 1000 },
          { value: '7d', label: 'Last 7 days', diff: 7 * 24 * 60 * 60 * 1000 },
          { value: '30d', label: 'Last 30 days', diff: 30 * 24 * 60 * 60 * 1000 },
        ],
      };
    },
    methods: {
      selectRange(range) {
        this.updateDateRange(range);
      },
    },
		props: {
      listType: String,
    },
		setup(props) {
			const store = useStore();
      const isExpanded = computed({
        get: () => store.state.chart.isFiltersExpanded,
        set: (val) => store.commit('chart/setFiltersExpanded', val)
      });
      const formatDateForInput = (dateStr) => {
        if (!dateStr) return '';
        const date = parseISO(dateStr);
        return isValid(date) ? format(date, "yyyy-MM-dd'T'HH:mm") : '';
      };

      let fromDate = computed(() => formatDateForInput(store.state.chart.filters.dateRange.fromDate[props.listType]));
      let toDate = computed(() => formatDateForInput(store.state.chart.filters.dateRange.toDate[props.listType]));

      const toggleFilters = () => {
        store.commit('chart/setFiltersExpanded', !store.state.chart.isFiltersExpanded);
      };

			function updateDateRange(range, update = true) {
				store.commit('chart/setDateRangeType', {listType: props.listType, dateRangeType: range.value});
        store.commit('chart/setDate',{listType: props.listType, date: new Date().toISOString(), which: 'toDate'});
        store.commit('chart/setDate',{listType: props.listType, date: new Date(Date.now() - range.diff).toISOString(), which: 'fromDate'});
        if (update)
          store.dispatch('register/loadRegister');
			}

			const setFromDate = (event) => {
        setDate(event, 'fromDate');
			}

			function setToDate(event) {
        setDate(event, 'toDate');
			}

      function setDate(event, which) {
        const val = event.target.value;
        let isoDate = '';
        if (val) {
          const d = parseISO(val);
          if (isValid(d)) isoDate = d.toISOString();
        }
        store.commit('chart/setDate',{listType: props.listType, date: isoDate, which: which});
        store.commit('chart/setDateRangeType', {listType: props.listType, dateRangeType: 'custom'});
        if (fromDate.value && toDate.value) {
          store.dispatch('register/loadRegister');
          document.querySelector('.custom-active')?.classList.remove('custom-active');
        }
      }

      const clearDates = () => {
        setDate({ target: { value: '' } }, 'fromDate');
        setDate({ target: { value: '' } }, 'toDate');
      };

			onMounted(() => {
        // Only set default range if not already set by URL parameters
        const currentRangeType = store.state.chart.filters.dateRangeType[props.listType];
        if (!currentRangeType) {
          updateDateRange({ value: '30r', label: 'Last 30 readings', diff: null }, false);
        }
      });

      const aiToggle = (e) => {
        store.commit("chart/setShowingPredictions", e.target.checked, { root: true });
      };

      const timeoutToggle = (e) => {
        store.commit("chart/setShowingTimeouts", e.target.checked, { root: true });
      };

      const alarmToggle = (e) => {
        store.commit("chart/setShowingAlarms", e.target.checked, { root: true });
      };

      const trendlineToggle = (e) => {
        store.commit("chart/setShowingTrendline", e.target.checked, { root: true });
      };

      const aiEnabled = computed(() => {
        let regAttrs = store.state.apgList.List.register_attribute;
        if (!regAttrs) return false;
        return regAttrs.find((item) => item?.attribute_name === 'predictions_enabled')?.attribute_value === 'true';
      });

      const removeOutliers = () => {
        store.dispatch("chart/removeOutliers", {
          listType: props.listType,
          id: store.state.sensor.id,
          address: store.state.apgList.List.sensor_overview?.find((item) => item.attribute_name === 'addressToRead')?.attribute_value,
        }, { root: true });
      };

      const alarmsEnabled = computed(() => {
        let sensorId = store.state.sensor.id;
        let address = store.state.register.address;
        return store.state.alarm.alarm_set.find(a => a.sensor_id == sensorId && a.alarm_register == address) != null;
      });

      // Watch for filter changes and update URL
      watch(
        () => [
          store.state.chart.filters.dateRangeType[props.listType],
          store.state.chart.filters.dateRange.fromDate[props.listType],
          store.state.chart.filters.dateRange.toDate[props.listType],
          store.state.chart.showing_predictions,
          store.state.chart.filters.showingTimeouts,
          store.state.chart.filters.showingAlarms,
          store.state.chart.filters.showingTrendline,
        ],
        () => {
          // Only update URL if we have a sensor selected
          if (store.state.MyView.selected.sensor?.id) {
            store.dispatch('MyView/updateUrlParameters');
          }
        },
        { deep: true }
      );

			return {
        isExpanded,
        toggleFilters,
				updateDateRange,
				setFromDate,
				setToDate,
				daterange: computed(() => store.state.chart.filters.dateRangeType[props.listType]),
        chartLoaded: computed(() => !store.state.settings.is_loading),
        selectedRange: computed(() => store.state.chart.filters.dateRangeType[props.listType]),
				fromDate,
				toDate,
        aiToggle,
        aiEnabled,
        aiEnabledVal: computed(() => store.state.chart.showing_predictions),
        removeOutliers,
        timeouts: computed(() => store.state.chart.unresponsive_data.group_gateway_sensor?.length > 0),
        timeoutToggle,
        timeoutVal: computed(() => store.state.chart.filters.showingTimeouts),
        alarms: computed(() => store.state.alarm.alarm_set),
        alarmToggle,
        alarmVal: computed(() => store.state.chart.filters.showingAlarms),
        alarmsEnabled,
        trendlineToggle,
        trendlineVal: computed(() => store.state.chart.filters.showingTrendline),
        clearDates,
        gatewayTier: computed(() => store.state.gateway.paid_tier),
			}
		}
	}
</script>

<style scoped>
.accordion {
  --bs-accordion-color: var(--color-txt);
}

input[type='date'] {
  pointer-events: none;
}

input[type='date']::-webkit-calendar-picker-indicator {
  pointer-events: auto;
  color-scheme: var(--scheme);
}

.form-control:disabled {
  background-color: var(--color-border);
  color: var(--color-txt);
}

.card-header {
  margin-bottom: 15px;
}

.custom-active {
  color: var(--color-txt) !important;
  background-color: var(--color-sec) !important;
  border-color: var(--color-sec) !important;
}
</style>
